import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { GlobalAiRovoButton } from './GlobalAiRovoButton.tsx';

export const GlobalAiRovoButtonWithBoundary = (): React.JSX.Element | null => {
	return (
		<JSErrorBoundary
			fallback="unmount"
			id="global-ai-rovo-button"
			packageName="ai-rovo-button"
			teamName="reverie"
		>
			<UFOSegment name="rovo-button">
				<GlobalAiRovoButton />
			</UFOSegment>
		</JSErrorBoundary>
	);
};
